import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {HttpClient} from '@angular/common/http';
import {Billingservices} from '../model/Billingservices';

@Injectable({
  providedIn: 'root'
})
export class BillingService {


  constructor(private http: HttpClient) {
  }

  public post(url: string, billingservices: Billingservices): Observable<Response> {
    return this.http.post<any>(url, JSON.stringify(billingservices), Headers.contentType);
  }

  public put(url: string, billingservices: Billingservices): Observable<Response> {
    return this.http.put<any>(url, JSON.stringify(billingservices), Headers.contentType);
  }

  public get(url: string) {
    return this.http.get(url);
  }
}
